import * as Tabs from '@radix-ui/react-tabs';
import { motion, AnimatePresence } from 'framer-motion';
import UsersFilters from './UsersFilters';
import UsersTable from './UsersTable';
import ProjectsFilters from './ProjectsFilters';
import ProjectsTable from './ProjectsTable';
import { useState } from 'react';

interface OrganizationTabsProps {
  children: React.ReactNode;
  activeTab: string;
  onTabChange: (value: string) => void;
  setRefreshMode?: (value: string) => void;
  setOrgFilters: (filters: any) => void;
  setUserFilters: (filters: any) => void;
  setProjectFilters: (filters: any) => void;
  orgFilters: any;
  userFilters: any;
  projectFilters: any;
  users: any[];
  projects: any[];
  handleRoleChange: (userId: string, newRole: string) => void;
  loadingUsers: boolean;
  loadingProjects: boolean;
  onRefreshProjects: () => void;
  onRefreshUsers?: () => void;
  type: string;
}

export default function OrganizationTabs({ children, activeTab, onTabChange,  setOrgFilters, setUserFilters, setProjectFilters, orgFilters, userFilters, projectFilters, users, projects, handleRoleChange, loadingUsers, loadingProjects, onRefreshProjects, onRefreshUsers,  type }: OrganizationTabsProps) {
  const [refreshMode, setRefreshMode] = useState('');
  const [activeProjectsTab, setActiveProjectsTab] = useState('operational');
  const [profileProducts, setProfileProducts] = useState<any>([]);

  return (
    <div>
      <Tabs.Root value={activeTab} onValueChange={onTabChange}>
        <div className="sticky top-0 pt-4 bg-black z-20 pb-4">
          <Tabs.List className="flex w-full">
            {type === "superadmin" && <Tabs.Trigger
              value="organizations"
              className={`px-6 py-2.5 text-sm transition-colors relative flex-1 max-w-[200px] ${
                activeTab === 'organizations' 
                  ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white rounded-lg'
                  : 'bg-[#2A2A2A] text-gray-400 rounded-l-lg'
              }`}
            >
              Organizations
            </Tabs.Trigger>}
            <Tabs.Trigger
              value="users"
              className={`px-6 py-2.5 text-sm transition-colors relative flex-1 max-w-[200px] ${
                activeTab === 'users' 
                  ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white rounded-lg' 
                  : 'bg-[#2A2A2A] text-gray-400'
                  + (type === "user" ? " rounded-l-lg" : "")
              }`}
            >
              Users
            </Tabs.Trigger>
            <Tabs.Trigger
              value="projects"
              className={`px-6 py-2.5 text-sm transition-colors relative flex-1 max-w-[200px] ${
                activeTab === 'projects' 
                  ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white rounded-lg' 
                  : 'bg-[#2A2A2A] text-gray-400 rounded-r-lg'
              }`}
            >
              Projects
            </Tabs.Trigger>
            <div className="flex-1 bg-[#2A2A2A] h-full" />
          </Tabs.List>

          <div className="mt-4">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.2 }}
              >
                { activeTab === 'users' ? (
                  <UsersFilters 
                    setFilters={setUserFilters}
                    type={type}
                    filters={userFilters}
                    users={users}
                  />
                ) : (
                  <ProjectsFilters 
                    setFilters={setProjectFilters}
                    filters={projectFilters}
                    projects={projects}
                    activeProjectsTab={activeProjectsTab}
                    setActiveProjectsTab={setActiveProjectsTab}
                    profileProducts={profileProducts}
                    setProfileProducts={setProfileProducts}
                  />
                )}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.2 }}
          >
            <Tabs.Content value="organizations">
              {activeTab === 'organizations' && children}
            </Tabs.Content>

            <Tabs.Content value="users">
              {activeTab === 'users' && <UsersTable filters={userFilters} users={users} handleRoleChange={handleRoleChange} loadingUsers={loadingUsers}
              type={type}
              refreshUsers={onRefreshUsers}
              />}
            </Tabs.Content>

            <Tabs.Content value="projects">
              {activeTab === 'projects' && <ProjectsTable 
              type={type}
              setRefreshMode={setRefreshMode} refreshMode={refreshMode} filters={projectFilters} activeProjectsTab={activeProjectsTab} setActiveProjectsTab={setActiveProjectsTab} profileProducts={profileProducts} setProfileProducts={setProfileProducts}/>}
            </Tabs.Content>
          </motion.div>
        </AnimatePresence>
      </Tabs.Root>
    </div>
  );
} 